<template>
  <div>
    <Header
      :menuData="menuData"
      :exibirGuiaCliente="exibirGuiaCliente"
      :menuItems="menuHeader"
      :contratos="$store.state.contratos"
    />

    <transition name="fade" mode="out-in">
      <router-view class="main-view"></router-view>
    </transition>

    <div class="box-lgpd" :class="{ '-show': exibirModalLGPD }">
      <TermoLGPD />

      <div class="container">
        <div class="buttons">
          <button type="button" @click="insertLGPD(true)">Aceito</button>

          <button type="button" @click="insertLGPD(false)">Não aceito</button>
        </div>
      </div>
    </div>

    <Footer /> <!-- /footer -->
  </div>
</template>

<script>
import Auth from '@/services/Auth'
import PagesService from '@/services/Pages'
import LGPDService from '@/services/LGPD'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TermoLGPD from '@/components/TermoLGPD'

export default {
  name: 'dash',

  components: {
    Header,
    Footer,
    TermoLGPD
  },

  data () {
    const data = {
      open: false,
      menuHeader: [],
      menuData: {},
      exibirGuiaCliente: false,
      exibirModalLGPD: false
    }

    return data
  }, // data()

  beforeMount () {
    // Seta as coisas no vuex
    let json = localStorage.getItem('STORAGE.DATA')

    if (json) {
      json = JSON.parse(json)

      const {
        Cliente,
        Personificado,
        Menu
      } = json

      const {
        codigoCliente,
        codigoUsuario,
        conjugeCPF,
        conjugeNome,
        documento,
        nome,
        email,
        contratos
      } = Cliente

      const contratoSelecionado = JSON.parse(localStorage.getItem('STORAGE.CONTRATOATUAL') || '""')

      const [contratoAtual] = contratos
      this.menuData = Menu
      this.$store.commit('setContratos', contratos)
      this.$store.commit('setContratoAtual', contratoSelecionado || contratoAtual)
      this.$store.commit('setDocumento', documento)
      this.$store.commit('setCodCliente', codigoCliente)
      this.$store.commit('setCodUsuario', codigoUsuario)
      this.$store.commit('setConjugeNome', conjugeNome)
      this.$store.commit('setConjugeCPF', conjugeCPF)
      this.$store.commit('setNome', nome)
      this.$store.commit('setEmail', email)
      this.$store.commit('setPersonificado', Personificado)
      this.$store.commit('setHeaderType', contratoAtual.empreendimentoIdWeb)
    } else {
      this.logout()
    }
  }, // beforeMount()

  mounted () {
    this.getBadges()
    this.getMenu()
    // this.getLGPD()
  }, // mounted()

  methods: {
    async getLGPD () {
      try {
        const { personificado, documento, nome, codigoCliente } = this.$store.state

        if (personificado) return

        if (!documento || !nome || !codigoCliente) return

        const acceptedLGPD = await LGPDService.verificar()

        this.exibirModalLGPD = !acceptedLGPD

        if (!acceptedLGPD) {
          document.body.classList.add('overflow-hidden')
        } else {
          document.body.classList.remove('overflow-hidden')
        }
      } catch (e) {
        console.error('Falha ao recuperar LGPD info', e)
      }
    },

    async insertLGPD (aceitou) {
      try {
        const { documento, nome, contratoAtual } = this.$store.state

        this.exibirModalLGPD = false
        document.body.classList.remove('overflow-hidden')

        await LGPDService.inserir({
          nomeCliente: nome,
          documentoCliente: documento,
          empreendimentoId: contratoAtual.empreendimentoIdWeb,
          aceitou
        })
      } catch (e) {
        console.error('Falha ao recuperar LGPD info', e)
      }
    },

    async getBadges () {
      try {
        let xhr = await PagesService.getInfoMenu(this.$store.state.contratoAtual.empreendimentoIdWeb, this.$store.state.codigoCliente)
        let emp = await PagesService.getEmp(this.$store.state.contratoAtual.empreendimentoIdWeb)

        this.exibirGuiaCliente = emp.empreendimento.exibirGuiaCliente

        this.$store.commit('setMenuInfo', xhr)
      } catch (e) {
        console.error('Falha ao recuperar badges', e)
      }
    }, // getBadges()

    async getMenu () {
      try {
        this.menuHeader = await PagesService.getMenu()
      } catch (e) {
        this.menuHeader = []
      }
    }, // getMenu()

    logout () {
      Auth.logout()
    }, // logout()

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    openMenu () {
      this.open = true
    }, // openMenu()

    closeMenu () {
      this.open = false
    } // closeMenu()
  } // methods
}
</script>

<style lang="sass" scoped>
  .box-lgpd
    position: fixed
    bottom: 0
    left: 0
    right: 0
    background: #fff
    z-index: 10000
    padding: 0
    opacity: 0
    pointer-events: none
    transition: all 100ms ease

    &.-show
      opacity: 1
      pointer-events: all

    .container
      width: 100%
      max-width: 1400px
      padding: 0 15px
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between

      @media (max-width: 1000px)
        flex-direction: column

      .buttons
        display: flex
        flex-direction: row
        align-items: center
        padding: 8px 0

        button
          margin: 0 15px
          background: #b9b9b9
          text-transform: uppercase
          color: #fff
          transition: all 150ms ease
          white-space: nowrap
          font-size: 16px
          font-weight: 700
          padding-left: 14px
          padding-right: 14px

          &:hover
            background: darken(#b9b9b9, 5%)
</style>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .main-view
    padding-top: 80px

  @media (max-width: 1024px)
    .main-view
      padding-top: 50px

  @media print
    header
      display: none

    .main-view
      padding-top: 10px

    footer
      display: none
</style>
